












import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'dn-button-loader',
})
export default class ButtonLoader extends Vue {
  @Prop({ type: Boolean, default: false }) isNested!: boolean;
}
